import { BasvuruFlow, type ProductConfig } from "./BasvuruFlow";
import { InfoNote, PlateField, PLATE_RE, RuhsatField } from "./shared";

// WEB3 — Trafik teklif-talebi. Founder field-set (2026-07-11): İsim Soyisim · TC ·
// Doğum tarihi · Plaka · Telefon · İl · İlçe · Ruhsat (dosya yükle, ZORUNLU +
// "telefonda ileteceğim" escape / KARAR-4). Marka/Model NOT asked — SBM derives them
// from plate + TC. The identity/contact/consent fields live in the shared step ②.

const config: ProductConfig = {
  product: "trafik",
  intro: {
    eyebrow: "TRAFİK SİGORTASI · TEKLİF TALEBİ",
    title: "Teklif akışı",
    text: "Aracınızın plakası ve ruhsatından kişisel bilgilerinize, oradan danışman eşleşmesine kadar tek odaklı adımlar. Büyük dokunma alanları, net ilerleme.",
  },
  headerTitle: "Trafik Sigortası",
  infoTitle: "Aracınızı tanıyalım",
  infoLead: "Plakanızı girin ve ruhsatınızı yükleyin.",
  renderInfo: (ctx) => (
    <>
      <PlateField
        value={ctx.fields.plaka ?? ""}
        onChange={ctx.setField("plaka")}
        error={ctx.errors.plaka}
      />
      <RuhsatField
        file={ctx.ruhsatFile}
        onFile={ctx.setRuhsatFile}
        escape={ctx.ruhsatEscape}
        onEscape={ctx.setRuhsatEscape}
        error={ctx.errors.ruhsat}
        status={ctx.ruhsatStatus}
        progress={ctx.ruhsatProgress}
        uploadError={ctx.ruhsatUploadError}
      />
      <InfoNote>
        Marka, model ve hasarsızlık basamağınız plaka ve TC’nizle SBM üzerinden otomatik gelir —
        sizi fazla bilgiyle yormayız.
      </InfoNote>
    </>
  ),
  validateInfo: (ctx) => {
    const e: Record<string, string> = {};
    const plaka = (ctx.fields.plaka ?? "").trim().toUpperCase();
    if (!plaka) e.plaka = "Plaka zorunlu.";
    else if (!PLATE_RE.test(plaka)) e.plaka = "Geçerli bir TR plaka girin (örn. 34 ABC 123).";
    if (!ctx.ruhsatEscape && !ctx.ruhsatFile)
      e.ruhsat = "Ruhsat zorunlu. Yükleyin ya da telefonda ileteceğinizi işaretleyin.";
    return e;
  },
  buildVehicle: (fields) => ({ plate: (fields.plaka ?? "").trim().toUpperCase() }),
  summary: (fields) => ({
    label: `Trafik · ${(fields.plaka ?? "").trim().toUpperCase() || "Aracınız"}`,
    value: "Teklif hazırlanıyor",
  }),
};

export function TrafikBasvuru() {
  return <BasvuruFlow config={config} />;
}
